import { useSessionStorageData } from '@/composables/self-service/useSessionStorageData'
import { SELF_SERVICE_PORTAL_SLUG } from '@/utils/constants/staticPages'

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) return

  const localePath = useLocalePath()
  const selfServicePath = computed(() => localePath(SELF_SERVICE_PORTAL_SLUG))

  const isNavigatingToSelfService = to.path === selfServicePath.value

  if (isNavigatingToSelfService) return

  const { clearCredentials } = useSessionStorageData()
  clearCredentials()
})
